// extracted by mini-css-extract-plugin
module.exports = {"subscriptionAgreement":"SubscriptionAgreement_subscriptionAgreement__gV_pd","subscriptionTitle":"SubscriptionAgreement_subscriptionTitle__THAbZ"};